import { ChevronRight } from 'lucide-react';
import React from 'react';
import { useLocation, Link } from 'react-router-dom';

// Define route mappings for breadcrumb labels
const routeLabels: Record<string, string> = {
  vorgaenge: 'Vorgänge',
  fehler: 'Fehler Management',
  vorgang: 'Vorgang Bearbeitung',
  archiv: 'Archiv',
  massenverarbeitung: 'Massenverarbeitung',
  konfiguration: 'Konfiguration',
  dokumenttypen: 'Dokumenttypen',
  streamserve: 'StreamServe',
};

// Define route params handling for dynamic routes
const getRouteLabel = (
  segment: string,
  params?: Record<string, string>,
): string => {
  if (segment.startsWith(':')) {
    // Handle dynamic segments like :id
    const paramName = segment.slice(1);
    return params?.[paramName] || segment;
  }
  return routeLabels[segment] || segment;
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();

  // Parse the pathname into segments
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Build breadcrumb items
  const breadcrumbItems = [];

  // Add path segments
  let currentPath = '';
  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;

    // Extract params for dynamic routes (e.g., correlation ID)
    const params: Record<string, string> = {};
    if (segment.match(/^\d+$/)) {
      // If segment is numeric, it's likely an ID
      params.id = segment;
    }

    // For dynamic routes, use a more descriptive label
    let label = getRouteLabel(segment, params);
    if (pathSegments[index - 1] === 'vorgang' && segment.match(/^\d+$/)) {
      label = `Correlation ID: ${segment}`;
    }

    breadcrumbItems.push({
      label,
      path: currentPath,
      isLast,
    });
  });

  return (
    <nav className="flex items-center space-x-1 text-sm text-header-text ">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={item.path}>
          {index > 0 && (
            <ChevronRight className="h-4 w-4 text-header-text/60" />
          )}
          {item.isLast ? (
            <span className="font-medium text-header-text">{item.label}</span>
          ) : (
            <Link
              to={item.path}
              className="text-header-text/80 hover:text-header-text transition-colors"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
